import React, {useState} from 'react'
import {UpdatePaymentPriceRequest} from '../../../../api/data-contracts'
import {postRequestAsync} from '../../../../redux/commonSlice'
import {Api_Admin_UpdatePaymentPrice} from '../../../../apiClient/apiClient'
import {BooleanApiData} from '../../../../api/data-contracts'
import {useDispatch} from 'react-redux'

function AdminPaymentPriceUpdate(props: {
  paymentId: number
  defaultAmount?: number
  load?: () => void
  close: () => void
}) {
  const dispatch = useDispatch()

  const [amount, setAmount] = useState(0)
  function updatePaymentPrice(paymentId: number, amount: number) {
    const body: UpdatePaymentPriceRequest = {
      paymentId: paymentId,
      amount: amount,
    }

    dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Admin_UpdatePaymentPrice,
        body: body,
      })
    )
      .unwrap()
      .then(async function (response: BooleanApiData) {
        if (response.data) {
          props.load && props.load()
          props.close && props.close()
        }
      })
  }

  return (
    <div className='row mb-5'>
      <div className='col-4 offset-2'>
        <input
          type='number'
          className='form-control'
          placeholder='Yeni ödeme tutarını giriniz'
          defaultValue={props.defaultAmount ?? 0}
          onChange={(e) => setAmount(Number(e.target.value))}
        />
      </div>
      <div className='col-4'>
        <button
          className='btn btn-primary'
          onClick={() => {
            updatePaymentPrice(props.paymentId ?? 0, amount)
          }}
        >
          Kaydet
        </button>
      </div>
    </div>
  )
}

export default AdminPaymentPriceUpdate
